const buttonSearch = document.querySelector('header .search-active');
if(buttonSearch != null) {
	const formBlock = document.querySelector('header .search-form');
	const formInput = document.querySelector('header .input-text');
	buttonSearch.addEventListener('click', ()=>{
		formBlock.classList.add('active');
		buttonSearch.classList.add('none');
		formInput.focus()
	});

}

const buttonSearchFooter = document.querySelector('footer .search-active');
if(buttonSearchFooter != null) {
	const formBlock = document.querySelector('footer .search-form');
	const formInput = document.querySelector('footer .input-text');
	buttonSearchFooter.addEventListener('click', ()=>{
		formBlock.classList.add('active');
		buttonSearchFooter.classList.add('none');
		formInput.focus()
	});
	formInput.addEventListener('blur', ()=>{
		formBlock.classList.remove('active');
		buttonSearchFooter.classList.remove('none');
	})
}



// WEBPACK FOOTER //
// ./scripts/search.js